import { toUserId } from '../../common/utils/ari';
import { DEFAULT_CONFIG } from '../constants';
import { BaseGraphQlClient } from '../graphql-client';
import { logException } from '../sentry/main';
import TeamMembershipsQuery from './utils/queries/team-membership-query';
export class AGGClient extends BaseGraphQlClient {
  constructor(baseUrl, config) {
    super(`${baseUrl}/graphql`, config);
  }
  setBaseUrl(baseUrl) {
    this.setServiceUrl(`${baseUrl}/graphql`);
  }
  async queryTeamMemberships(teamId, membershipState = ['FULL_MEMBER'], pageInfo = {
    first: 100
  }) {
    const response = await this.makeGraphQLRequest({
      query: TeamMembershipsQuery,
      variables: {
        teamId,
        membershipState,
        siteId: this.getCloudId(),
        ...pageInfo
      }
    }, {
      operationName: 'TeamMembership'
    });
    return {
      edges: response.team.teamV2.members.edges.map(({
        node
      }) => {
        var _node$member$extended, _node$member$extended2;
        return {
          membershipId: {
            teamId,
            memberId: toUserId(node.member.id)
          },
          state: node.state,
          role: node.role,
          user: {
            id: toUserId(node.member.id),
            fullName: node.member.name,
            avatarUrl: node.member.picture,
            status: node.member.accountStatus,
            title: (_node$member$extended = (_node$member$extended2 = node.member.extendedProfile) === null || _node$member$extended2 === void 0 ? void 0 : _node$member$extended2.jobTitle) !== null && _node$member$extended !== void 0 ? _node$member$extended : undefined
          }
        };
      }),
      pageInfo: response.team.teamV2.members.pageInfo
    };
  }
}
export const aggClient = new AGGClient(DEFAULT_CONFIG.stargateRoot, {
  logException
});